import { streamConstants } from '../constants/streams';
import { streams, offers, streamsTDS } from '../services/ApiService';

export const addStream = (stream = {}) => ({
  type: streamConstants.ADD_STREAM_SUCCESS,
  stream,
});
export const startAddStream = stream => dispatch =>
  streams.addStream(stream).then((data = { items: [] }) => dispatch(addStream(data.items[0])));

export const startAddStreamTDS = stream => dispatch =>
  streamsTDS
    .addStreamTDS(stream)
    .then((data = { items: [] }) => dispatch(addStream(data.items[0])));

export const setStream = (stream = {}) => ({
  type: streamConstants.SET_STREAM_SUCCESS,
  stream,
});

export const editStream = updates => ({
  type: streamConstants.EDIT_STREAM_SUCCESS,
  updates,
});

export const startEditStream = (streamId, updates) => dispatch =>
  streams.update(streamId, updates).then((data = {}) => dispatch(editStream(data.items)));

export const startEditStreamTDS = (streamId, updates) => dispatch =>
  streamsTDS.updateTDS(streamId, updates).then((data = {}) => dispatch(editStream(data.items)));

export const startSetStream = streamId => dispatch =>
  streams
    .getStream(streamId)
    .then((data = { items: [] }) => dispatch(setStream(data.items[0])))
    .catch(err => dispatch({ type: streamConstants.SET_STREAM_FAILURE }));

export const startSetStreamTDS = streamId => dispatch =>
  streamsTDS
    .getStreamTDS(streamId)
    .then((data = { items: [] }) => dispatch(setStream(data.items[0])))
    .catch(err => dispatch({ type: streamConstants.SET_STREAM_FAILURE }));

export const setStreams = (streams = [], count = 0, settings = {}) => ({
  type: streamConstants.SET_STREAMS_SUCCESS,
  streams,
  count,
  settings,
});

export const startSetStreams = params => dispatch =>
  streams
    .getStreams(params)
    .then((data = {}) => dispatch(setStreams(data.items, data.count, data.info)))
    .catch(err => dispatch({ type: streamConstants.SET_STREAMS_FAILURE }));

export const startCopyStream = (streamId, title, callback) => dispatch => 
  streams
    .getStream(streamId)
    .then( data => callback({...data.items[0], newTitle: title}))
    .then( copyStream => dispatch(startAddStream(copyStream)))
    .catch(err => dispatch({type: streamConstants.COPY_STREAM_FAILURE}));
  
export const removeStream = streamId => ({
  type: streamConstants.REMOVE_STREAM_SUCCESS,
  streamId,
});

export const startRemoveStream = streamId => dispatch =>
  streams
    .removeStream(streamId)
    .then(() => dispatch(removeStream(streamId)))
    .catch(err => dispatch({ type: streamConstants.REMOVE_STREAM_FAILURE }));

export const startRemoveStreamTDS = streamId => dispatch =>
  streamsTDS
    .removeStreamTDS(streamId)
    .then(() => dispatch(removeStream(streamId)))
    .catch(err => dispatch({ type: streamConstants.REMOVE_STREAM_FAILURE }));

export const setStreamSettings = settings => ({
  type: streamConstants.SET_STREAM_SETTINGS_SUCCESS,
  settings,
});

export const startSetStreamSettings = () => dispatch =>
  streams
    .getSettings()
    .then((data = {}) => dispatch(setStreamSettings(data.items)))
    .catch(err => dispatch({ type: streamConstants.SET_STREAM_SETTINGS_ERROR }));

export const setStreamLandingSettings = (settings = []) => ({
  type: streamConstants.SET_STREAM_LANDING_SETTINGS_SUCCESS,
  settings,
});

export const startSetStreamLandingFeaturesSettings = () => dispatch =>
  streams
    .getLandingFeaturesSettings()
    .then((data = {}) => dispatch(setStreamLandingSettings(data.items)))
    .catch(err => dispatch({ type: streamConstants.SET_STREAM_LANDING_SETTINGS_FAILURE }));

export const setStreamOffer = (offer = {}) => ({
  type: streamConstants.SET_STREAM_OFFER_SUCCESS,
  offer,
});

export const startSetStreamOffer = offerId => dispatch => {
  dispatch({ type: streamConstants.SET_STREAM_OFFER_REQUEST });

  return offers
    .getOfferInfo(offerId)
    .then((data = { items: [] }) => {
      return dispatch(setStreamOffer(data.items[0]));
    })
    .catch(err => {
      if (err.response.data.error.message.type === 'api.offers.blocked') {
        return dispatch({
          type: streamConstants.SET_STREAM_OFFER_FAILURE,
          payload: { id: offerId, title: `Оффер ${offerId} заблокирован` },
        });
      }
      return dispatch(setStreamOffer({ id: offerId }));
    });
};

export const editGlobalPostback = (globalPostback = {}) => ({
  type: streamConstants.SET_GLOBAL_POSTBACK_SUCCESS,
  globalPostback,
});

export const startEditGlobalPostback = data => dispatch =>
  streams.updateGlobalPostback(data).then(() => dispatch(editGlobalPostback(data)));

export const setGlobalPostback = (globalPostback = {}) => ({
  type: streamConstants.SET_GLOBAL_POSTBACK_SUCCESS,
  globalPostback,
});

export const startSetGlobalPostback = () => dispatch =>
  streams
    .getGlobalPostback()
    .then(({ items }) => dispatch(setGlobalPostback(items)))
    .catch(err =>
      dispatch({
        type: streamConstants.SET_GLOBAL_POSTBACK_FAILURE,
      }),
    );

export const resetStream = () => ({
  type: streamConstants.RESET_STREAM,
});

export const resetStreamOffer = () => ({
  type: streamConstants.RESET_STREAM_OFFER,
});

// RESET_FLOWS_FILTERS
export const resetStreamsFilter = name => ({
  type: streamConstants.RESET_STREAMS_FILTER,
  name,
});

// SET_FLOWS_FILTERS
export const setStreamsFilter = (filters = {}) => ({
  type: streamConstants.SET_STREAMS_FILTER,
  filters,
});

export const resetSearch = () => ({
  type: streamConstants.RESET_STREAMS_FILTER,
  filters: { id: [] },
});

// SEARCH FLOWS
// export const startSearchStreams = params => dispatch =>
//   streams.getStreams(params).then(data => {
//     const result = { id: data.items.map(stream => stream.id) };
//     return dispatch(setStreamsFilter(result));
// });
